import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid, TextField, Button } from "@mui/material";
import BackButton from "components/shared/BackButton";
import { StyledStack, ButtonContainer, StyledTitle } from "./AddNotif.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import PaginationCM from "components/shared/Pagination";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import NotifCard from "components/NotifCard";
import { FrameSchema } from "validations";
import {
  getNotificationFrameRequest,
  deleteNotificationFrameRequest,
  addNotificationFrameRequest,
} from "api/requests";
import { PAGINATION_LIMIT } from "constants";

export default function Notification() {
  const [frame, setFrame] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FrameSchema),
    defaultValues: {
      title: "",
      text: "",
    },
  });

  const onSubmit = async (values) => {
    const res = await request({
      url: addNotificationFrameRequest,
      values,
    });

    if (res) {
      Toast({ type: "success", title: "ثبت قالب" });
    }
    getFrame();
  };

  const handelDelete = async (id) => {
    const res = await request({
      url: deleteNotificationFrameRequest,
      values: id,
    });

    getFrame();

    if (res) Toast({ type: "success", title: "حذف" });
  };

  const getFrame = useCallback(async () => {
    const res = await request({
      url: getNotificationFrameRequest,
      values: { skip: (page - 1) * PAGINATION_LIMIT, limit: PAGINATION_LIMIT },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      text: items.text,
    }));

    if (res) {
      resetField("title");
      resetField("text");
    }

    setFrame({ data: transformedData, count: res.count });
  }, [page, resetField, request]);

  useEffect(() => {
    getFrame();
  }, [page, getFrame]);

  return (
    <DrawerCM title="افزودن قالب پیام">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن قالب</StyledTitle>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helperText={errors.title?.message}
                />
              </Grid>
              <Grid item xs={12} pt={2}>
                <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helperText={errors.text?.message}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
              {frame.data.length > 0 ? (
                <Fragment>
                  <StyledTitle>قالب ها</StyledTitle>
                  <NotifCard
                    rows={frame.data}
                    page={page}
                    onDelete={handelDelete}
                  />
                  <PaginationCM
                    handleChange={(e, val) => setPage(val)}
                    page={page}
                    count={frame.count}
                  />
                </Fragment>
              ) : (
                " "
              )}
            </Grid>
          </StyledStack>
        </Fragment>
      )}
    </DrawerCM>
  );
}
